import { PROJECT_SERVICE, USER_SERVICE } from "../consts";

export const PROJECT_API = `${PROJECT_SERVICE}projects`;
export const TASK_CATEGORY_API = `${PROJECT_SERVICE}task-categories`;
export const TASK_SUB_CATEGORY_API = `${PROJECT_SERVICE}task-sub-categories`;
export const QUALITY_CHECKLIST_API = `${PROJECT_SERVICE}task-quality-checklists`;
export const SAFETY_CHECKLIST_API = `${PROJECT_SERVICE}task-safety-checklists`;
export const TEAM_ASSIGN_API = `${USER_SERVICE}projects`;
export const USER_ROLES_API = `${USER_SERVICE}user-roles`;
